export function roundUsdToTier(usd: number): 10 | 100 | 200 | 400 | 500 | 700 | 1000 {
  if (usd <= 55) return 10
  if (usd <= 150) return 100
  if (usd <= 300) return 200
  if (usd <= 450) return 400
  if (usd <= 600) return 500
  if (usd <= 850) return 700
  return 1000
}
